module.exports = __webpack_public_path__ + "img/lg_ring_g_e_0_0.0ca5ab13.png";